import { API_ENDPOINTS } from "config/config";

export const ATTRIBUTION_PLATFORMS = [
  "Instagram",
  "Facebook",
  "TikTok",
  "YouTube",
  "Email",
  "Direct",
  "Skool",
];

export const ATTRIBUTION_ACCOUNTS = ["Nico", "Jordi", "BV1"];

export const ATTRIBUTION_ENTRY_POINTS = [
  "Bio Link",
  "Stories",
  "Story Reply",
  "ManyChat",
  "Email Sequence",
  "Email Broadcast",
  "YT Description",
  "Paid Ads",
];

export const DIMENSION_TYPES = [
  { value: "platform", label: "Platform" },
  { value: "account", label: "Account" },
  { value: "entryPoint", label: "Entry Point" },
];

export const UTM_FIELDS = [
  { value: "source", label: "UTM Source" },
  { value: "medium", label: "UTM Medium" },
  { value: "campaign", label: "UTM Campaign" },
];

export const CANONICAL_BY_DIMENSION = {
  platform: ATTRIBUTION_PLATFORMS,
  account: ATTRIBUTION_ACCOUNTS,
  entryPoint: ATTRIBUTION_ENTRY_POINTS,
};

export const UTM_FIELD_BY_DIMENSION = {
  platform: "source",
  account: "campaign",
  entryPoint: "medium",
};

export const getAttributionMappings = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.ATTRIBUTION_MAPPINGS, { params });
  return response.data.data;
};

export const createAttributionMapping = async (api, payload) => {
  const response = await api.post(API_ENDPOINTS.ATTRIBUTION_MAPPINGS, payload);
  return response.data;
};

export const updateAttributionMapping = async (api, id, payload) => {
  const response = await api.put(`${API_ENDPOINTS.ATTRIBUTION_MAPPINGS}/${id}`, payload);
  return response.data;
};

export const deleteAttributionMapping = async (api, id) => {
  const response = await api.delete(`${API_ENDPOINTS.ATTRIBUTION_MAPPINGS}/${id}`);
  return response.data;
};
